import {
  Box,
  Divider,
  Typography,
  Select,
  MenuItem,
  FormControl,
  Stack,
} from "@mui/material";
import { useComments } from "./useComments";
import { CommentBox } from "./CommentBox";
import { CommentInput } from "./CommentInput";
import { useState, useMemo, FC } from "react";

interface CommentWidgetProps {
  title?: string;
  buttonLabel?: string;
}

export const CommentWidget: FC<CommentWidgetProps> = ({
  title = "Comments",
  buttonLabel = "Add Comments",
}) => {
  const { comments, addComment } = useComments();
  const [sortOrder, setSortOrder] = useState<"asc" | "desc">("desc");

  const sortedComments = useMemo(() => {
    return [...comments].sort((a, b) => {
      const dateA = new Date(a.created_at).getTime();
      const dateB = new Date(b.created_at).getTime();
      return sortOrder === "asc" ? dateA - dateB : dateB - dateA;
    });
  }, [comments, sortOrder]);

  return (
    <Box id={"comments_section"}>
      <Box display="flex" justifyContent="space-between" alignItems="center">
        <Typography variant="h5">{title}</Typography>
        <Stack direction="row" spacing={2} alignItems="center">
          <Box>Sort By:</Box>
          <FormControl size="small" sx={{ minWidth: 120 }}>
            <Select
              value={sortOrder}
              size="small"
              onChange={(e) => setSortOrder(e.target.value as "asc" | "desc")}
              disabled={comments.length === 0}
            >
              <MenuItem value="desc">Newest first</MenuItem>
              <MenuItem value="asc">Oldest first</MenuItem>
            </Select>
          </FormControl>
        </Stack>
      </Box>
      <Box my={2}>
        <CommentInput
          onSubmit={(comment) => {
            addComment(comment);
          }}
          buttonLabel={buttonLabel}
        />
      </Box>
      <Divider />
      <Box>
        {sortedComments.map((comment, index) => (
          <Box key={comment.feedback_comment_id}>
            <CommentBox comment={comment} />
            <Divider
              sx={{
                display: index + 1 === sortedComments.length ? "none" : "block",
              }}
            />
          </Box>
        ))}
      </Box>
    </Box>
  );
};
